import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loadingspinner',
    templateUrl: './loadingspinner.component.html',
    styleUrls: ['./loadingspinner.component.scss'],
    standalone: false
})
export class LoadingspinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
